import { render } from "./GoogleRegistrationButton.vue?vue&type=template&id=7177d6fd&scoped=true"
import script from "./GoogleRegistrationButton.vue?vue&type=script&lang=js"
export * from "./GoogleRegistrationButton.vue?vue&type=script&lang=js"

import "./GoogleRegistrationButton.vue?vue&type=style&index=0&id=7177d6fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7177d6fd"]])

export default __exports__